import { NetworkStatus, useQuery } from '@apollo/client';

import {
  GetToolboxCollectionsDocument,
  GetToolboxCollectionsQueryVariables,
} from './getToolboxCollections.gql';

const COLLECTIONS_PER_PAGE = 20;

const useGetToolboxCollections = ({
  after = null,
  first = COLLECTIONS_PER_PAGE,
}: Partial<GetToolboxCollectionsQueryVariables> = {}) => {
  const {
    data,
    fetchMore: apolloFetchMore,
    networkStatus,
    ...hook
  } = useQuery(GetToolboxCollectionsDocument, {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: { after, first },
  });

  const cursor = data?.toolboxCollections.pageInfo.endCursor;
  const canFetchMore = data?.toolboxCollections.pageInfo.hasNextPage;
  const fetchingMore = networkStatus === NetworkStatus.fetchMore;
  const items = data?.toolboxCollections.edges.map(({ node }) => node);

  const fetchMore = () =>
    apolloFetchMore({
      variables: {
        after: cursor,
        first,
      },
    });

  return {
    ...hook,
    canFetchMore,
    fetchingMore,
    fetchMore,
    items,
  };
};

export type ToolboxCollections = NonNullable<
  ReturnType<typeof useGetToolboxCollections>['items']
>;

export default useGetToolboxCollections;
